import React, { Fragment } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { IconCalendarClock, IconCategory, IconCategoryFilled, IconShip, IconUser, IconUserFilled, IconX } from '@tabler/icons-react'
import { RouteConstant } from '../../routes/RouteConstant'
import { setActiveTab, setToggle } from '../../redux/reducers/settingsReducers'
import { Menu } from 'lucide-react'

const Sidebar = () => {
  
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const user = useSelector(state => state.auth.user)

    const activeTab = useSelector(state => state.settings.activeTab)
    const toggle = useSelector(state => state.settings.toggle)

    const menuItems = [
      {
        name: 'Dashboard',
        icon: (active) =>  active ? <IconCategoryFilled size="19px" /> : <IconCategory size="19px" />,
        link: RouteConstant.ROOT,
        roles: ['company_admin'],
      },
      {
        name: 'Users',
        icon: (active) => active ? <IconUserFilled size="19px" /> : <IconUser size="19px" />,
        link: RouteConstant.USERS,
        roles: ['company_admin'],
      },
      {
        name: 'Vessels',
        icon: (active) => active ? <IconShip size="19px" /> : <IconShip size="19px" />,
        link: RouteConstant.VESSEL,
        roles: ['company_admin'],
      }
    ]

    const handleNavigate = (link) => {
      navigate(link)
      dispatch(setActiveTab(link))
    }
  
    const handleToggle = () => {
      dispatch(setToggle(!toggle))
    };

  return (
    <Fragment>

        <div className={`${toggle?"w-[270px]":"w-[80px]"} h-full bg-primary fixed top-0 max-[768px]:hidden text-[14px] overflow-x-auto scroll-smooth scrollbar-hide`}>          
          <button className={`${toggle?"h-[70px] flex items-center justify-end w-full pr-4":"h-[70px] flex items-center justify-center w-full"}`} onClick={handleToggle}>
            {
              toggle?
              <IconX size={30} className='p-[5px]' color='white' />:
              <Menu size={30} className='p-[5px]' color='white' />
            }
          </button>
          <div className='text-white'>
              {menuItems?.map((item, index)=> {
                const userRoleNames = user.roles.map(role => role.name);
                const hasAccess = item.roles.some(role => userRoleNames.includes(role));
                if(!hasAccess){
                  return null
                }
                return(
                    <button
                    key={index} 
                    onClick={()=>handleNavigate(item?.link)}
                    className={`w-full px-4 py-1 outline-none ${toggle ? 'justify-start' : 'justify-center'}`}>
                      <div className={`flex items-center gap-4 w-full rounded-xl px-4 py-[10px] ${activeTab === item?.link && 'bg-white text-primary'}`}>
                        {item.icon(item?.link === activeTab)}
                        {toggle && <div className='text-[16px] font-semibold'>{item?.name}</div> }
                      </div>
                    </button>
                )}
              )}
          </div>
        </div>

        <div className={`hidden ${toggle?"w-[270px] max-[768px]:block":"hidden"} h-full z-[998] bg-primary rounded-tr-[10px] rounded-br-2xl shadow-md fixed top-0 overflow-x-auto scroll-smooth scrollbar-hide z`}>
            <button className={`${toggle?"h-[70px] flex items-center justify-end w-full pr-4":"h-[70px] flex items-center justify-center w-full"}`} onClick={handleToggle}>
              {
                toggle?
                <IconX size={30} className='p-[5px]' color='white' />:
                <Menu size={30} className='p-[5px]' color='white' />
              }
            </button>
            <div className='text-white'>
                 {menuItems?.map((item, index)=> {
                    const check = !item?.department?.includes(user?.dept_id)
                    if(check){
                      return null
                    }
                    return(
                        <button 
                        key={index} 
                        onClick={()=>handleNavigate(item?.link)}
                        className={`flex items-center gap-4 w-full p-4 ${toggle ? 'justify-start' : 'justify-center'} ${activeTab === item?.link && 'bg-white text-primary'}`}
                        >
                          {item.icon(item?.link === activeTab)}
                          {toggle && <div className='text-[15px] font-normal pt-[2px]'>{item?.name}</div> }
                        </button>
                    )}
                  )}      
            </div>
        </div>
    </Fragment>
  )
}

export default Sidebar